import React from "react";

export const ToggleButton = ({ title, onClick, classname }) => {
  return (
    <button className={classname} onClick={onClick}>
      {title}
    </button>
  );
};